import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20731d60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-checkbox" }
const _hoisted_2 = ["id", "checked", "name", "disabled"]
const _hoisted_3 = ["data-cy"]
const _hoisted_4 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      id: _ctx.id,
      type: "checkbox",
      checked: _ctx.isChecked,
      name: _ctx.name,
      disabled: _ctx.disabled || (_ctx.isForceSelect && _ctx.isChecked),
      onInput: _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:isChecked', e.target.checked))
    }, null, 40, _hoisted_2),
    _createElementVNode("span", {
      class: _normalizeClass(`checkmark`),
      "data-cy": `custom-table-can-drag-drop-custom-check-box-${_ctx.type}`,
      style: _normalizeStyle(`height: ${_ctx.size};width: ${_ctx.size}; background-color: ${_ctx.bgColor}`)
    }, null, 12, _hoisted_3),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1)
  ]))
}